import { Component } from "@angular/core";
import { FullScreenService } from "@services/fullscreen.service";
import "./fullScreenButton.scss";

@Component({
    selector: 'full-screen-button',
    template: require('./fullScreenButton.html')
})
export class FullScreenButtonComponent {
    isFullScreen: boolean = false;

    constructor(private fullScreenService: FullScreenService) { }

    toggleFullScreen(event: any) {
        const elementToToggle = event.target.parentNode.parentNode;
        this.isFullScreen = this.fullScreenService.toggle(elementToToggle);
    }
}
